


































































































































































import { Meta } from "@/store/meta"
import { Component } from "vue-property-decorator"
import { Server, Partner } from '@/store/server'
import { getModule } from "vuex-module-decorators"

import ConfirmModal from '@/components/ConfirmModal.vue'
import { mixins } from "vue-class-component"
import { DateTime } from "@/mixins/datetime"

@Component({
  components: {
      'confirm-modal': ConfirmModal
  }
})

export default class BroadcastDetail extends mixins(DateTime) {
  isLoading = true
  partners: Partner[] = []

  // modal
  isConfirmModalActive = false
  isAlertModalActive = false
  checkTitle = '確認'
  alertContent = ''
  checkContents = [{}]

  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }

  get detail() {
    return this.server.BroadcastMessagesDataDetail
  }

  get isPrivileged() {
    return this.server.loginInfo.privileged
  }

  get isViewer() {
    return this.meta.isViewer
  }

  get filteredPartnerLabels(): string[] {
    const codes = this.detail.message.partner_codes
    if (!codes || codes.length === 0) return []
    return codes.map(code => {
      const partner = this.partners.find(p => p.code === code)
      return partner && partner.memo ? `${code} (${partner.memo})` : code
    })
  }

  async mounted() {
    const queryId = `${this.$route.params.id}`
    await this.server.getBroadcastMessagesDetail(Number(queryId))
    if (this.isPrivileged) {
      try {
        this.partners = await this.server.getPartners()
      } catch (e) {
        console.warn('failed to fetch partners', e)
      }
    }
    this.isLoading = false
  }

  deleteButtonPushed(){
    this.checkContents.splice(0)
    this.checkContents.push({title:'', value:'本メッセージの予約配信を削除します。よろしいですか？'})
    this.isConfirmModalActive = true
    return
  }

  async deleteBroadcastMessagesDetail(id: number) {
    
    try {
      await this.server.deleteBroadcastMessagesDetail(id)
      this.$buefy.toast.open({
                    duration: 5000,
                    message: '配信の設定の削除が完了しました。',
                    type: 'is-link'
                })
      this.$router.push({ path: '/messages'});
    } catch (e) {
      this.$buefy.toast.open({
                    duration: 10000,
                    message: '削除に失敗しました。<br>大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。',
                    type: 'is-danger'
                })
    }
  }
}
